import { render, staticRenderFns } from "./createRule.vue?vue&type=template&id=cb070112&"
import script from "./createRule.vue?vue&type=script&lang=js&"
export * from "./createRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports